/** Persists whether the user has seen the Garmin Historical Data pre-connect guide. */
const STORAGE_KEY = 'vo2_garmin_connect_sheet_seen';

export function hasSeenGarminConnectSheet(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markGarminConnectSheetSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* private mode / quota */
  }
}
